/* eslint-disable no-irregular-whitespace */
import React from 'react';
import * as styles from './prices.module.scss';
import { OtTemplateQuery, SanityLocaleString } from '../../../../graphql-types';
import { usePageContext } from '../../../hooks/contexts/usePageContext';

interface IPricesProps {
  prices: NonNullable<OtTemplateQuery['ingenieOt']>['tarifs'];
}

type Prices = {
  id: string;
  libelle: SanityLocaleString;
  prix: number;
  complement?: string;
};

type DictPrices = {
  [key: string]: Prices;
};

type ArrPrices = Prices[];

const computePrice = (tarifs) => {
  const prices: DictPrices = {};
  tarifs.forEach((x) => {
    if (!prices[x.id]) {
      prices[x.id] = {
        id: x.id,
        libelle: x.libelle,
        prix: parseFloat(x?.prix_min),
        complement: x.complement,
      };
    } else if (x.prix_min < prices[x.libelle.fr].prix) prices[x.id].prix = parseFloat(x?.prix_min);
  });

  const res: ArrPrices = [];
  Object.keys(prices).forEach((key) => {
    res.push({
      id: prices[key].id,
      libelle: prices[key].libelle,
      prix: prices[key].prix,
      complement: prices[key].complement,
    });
  });
  return res;
};

export const PricesSection = ({ prices }: IPricesProps) => {
  const { lang } = usePageContext();
  const computedPrices = computePrice(prices);

  return (
    <ul className={styles.wrapper}>
      {computedPrices.map((x) => (
        <li key={x?.id}>
          <div
            className={styles.label}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: `${x?.libelle?.[lang]} ${
                x?.complement?.[lang] ? `${x?.complement?.[lang]}` : ''
              }`,
            }}
          />
          <div className={styles.price}>{`${(Math.round(x.prix * 100) / 100).toFixed(2)} €`}</div>
        </li>
      ))}
    </ul>
  );
};
